import axios from 'axios'
import { message } from 'ant-design-vue'
import store from '@/store'
import router from '@/router'

// 根据环境变量判断是否使用代理
const useProxy = process.env.VUE_APP_USE_PROXY === 'true'
// 回退示例正式站：https://cb.cibeiai.com；测试站：https://cibeicsy.2kang.cn
// const baseURL = useProxy ? '/api' : (process.env.VUE_APP_BASE_API || 'https://cb.cibeiai.com')
const baseURL = useProxy ? '/api' : process.env.VUE_APP_BASE_API

// 创建上传专用的 axios 实例
const uploadService = axios.create({
  baseURL,
  timeout: 600000, // 上传超时时间更长
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

// 请求拦截器
uploadService.interceptors.request.use(
  config => {
    // 从 store 获取 token
    const token = store.getters['user/token']
    if (token) {
      config.headers.Authorization = `${token}`
    }
    return config
  },
  error => {
    console.error('上传请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器 - 上传接口返回 code: 1 表示成功
uploadService.interceptors.response.use(
  response => {
    const res = response.data

    // 上传接口：code: 1 表示成功，code: 0 或其他表示失败
    if (res.code !== undefined && res.code !== 1) {
      message.error(res.msg || res.message || '上传失败')
      return Promise.reject(new Error(res.msg || res.message || '上传失败'))
    }

    return res
  },
  error => {
    console.error('上传响应错误:', error)
    let errorMessage = '上传失败'

    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMessage = '未授权，请重新登录'
          store.dispatch('user/logout')
          router.push('/login')
          break
        case 403:
          errorMessage = '拒绝访问'
          break
        case 404:
          errorMessage = '上传接口不存在'
          break
        case 500:
          errorMessage = '服务器错误'
          break
        default:
          errorMessage = `上传失败：${error.response.status}`
      }
    } else if (error.request) {
      errorMessage = '网络连接失败'
    } else {
      errorMessage = error.message
    }

    message.error(errorMessage)
    return Promise.reject(error)
  }
)

export default uploadService
